import React from 'react';
import Page from '../page';

export default function ByAccounts() {
  return <Page type="account" pageName="By_Account"></Page>;
}
